import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CityPage from "@/pages/CityPage";
import TreatmentPage from "@/pages/TreatmentPage";
import Blog from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Testimonials from "@/pages/Testimonials";
import FAQsPage from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Videos from "@/pages/Videos";
import Gallery from "@/pages/Gallery";
import Research from "@/pages/Research";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { CONDITIONS, CITY_PAGES } from "@/data/clinic";

// Build dynamic route lists from data
const treatmentSlugs = CONDITIONS.map((c) => c.slug);
const citySlugs = CITY_PAGES.map((c) => c.slug);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />

              {/* About */}
              <Route path="/about-dr-ashutosh-mishra" element={<About />} />

              {/* City pages */}
              {citySlugs.map((s) => (
                <Route key={s} path={`/${s}`} element={<CityPage slug={s} />} />
              ))}

              {/* Treatment pages */}
              {treatmentSlugs.map((s) => (
                <Route key={s} path={`/${s}`} element={<TreatmentPage slug={s} />} />
              ))}

              {/* Resources */}
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/patient-testimonials" element={<Testimonials />} />
              <Route path="/research-publications" element={<Research />} />
              <Route path="/faqs" element={<FAQsPage />} />
              <Route path="/contact" element={<Contact />} />

              {/* Legal */}
              <Route path="/privacy-policy" element={<LegalPage which="privacy" />} />
              <Route path="/terms" element={<LegalPage which="terms" />} />
              <Route path="/disclaimer" element={<LegalPage which="disclaimer" />} />

              {/* Backward-compat redirects from earlier URLs */}
              <Route path="/about" element={<Navigate to="/about-dr-ashutosh-mishra" replace />} />
              <Route path="/blogs" element={<Navigate to="/blog" replace />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/testimonials" element={<Navigate to="/patient-testimonials" replace />} />
              <Route path="/treatments/diabetes-treatment" element={<Navigate to="/diabetes-treatment-varanasi" replace />} />
              <Route path="/treatments/thyroid-treatment" element={<Navigate to="/thyroid-treatment-varanasi" replace />} />
              <Route path="/treatments/pcos-treatment" element={<Navigate to="/pcos-treatment-varanasi" replace />} />
              <Route path="/treatments/obesity-management" element={<Navigate to="/obesity-management-varanasi" replace />} />
              <Route path="/treatments/hormonal-disorders" element={<Navigate to="/hormonal-disorders-treatment-varanasi" replace />} />
              <Route path="/treatments/preventive-nephrology" element={<Navigate to="/preventive-nephrology-varanasi" replace />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
